package ui.screens.onboarding

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import data.repository.FirebaseInvitationRepo
import models.Wonder
import org.jetbrains.compose.resources.painterResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.background_flower
import thewedding_cmp.composeapp.generated.resources.photo_5
import ui.screens.GreetingByPath
import ui.theme.ColorScheme
import utils.AudioPlayer

@Composable
fun GateContent(
    initialWonder: Wonder,
    openHomeScreen: (Wonder) -> Unit,
    openNotInvited: () -> Unit,
    audioPlayer: AudioPlayer,
    modifier: Modifier = Modifier,
) = BoxWithConstraints(modifier.fillMaxSize()) {
    val repo = FirebaseInvitationRepo()
    val guestName = GreetingByPath()
    val nameInvited by repo.checkInvitationByName(guestName).collectAsState(initial = null)
    val opened = rememberSaveable(guestName) { mutableStateOf(false) }

    LaunchedEffect(nameInvited) {
        nameInvited?.let {
            if (!opened.value) {
                opened.value = true
                println("Gate, Nama undangan ${it.key}, exists ${it.exists}")
                if (!it.exists) {
                    openNotInvited()
                }
            }
        }
    }

    // Background image (full)
    Image(
        painter = painterResource(Res.drawable.background_flower),
        contentDescription = "Background",
        modifier = Modifier.fillMaxSize().background(color = Color.White),
        contentScale = ContentScale.Crop
    )

    // Semi-transparent overlay to improve text contrast
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(
                Brush.verticalGradient(
                    colors = listOf(Color(0x00000000), Color(0x7F000000)),
                    startY = 0f,
                    endY = Float.POSITIVE_INFINITY
                )
            )
    )

    // Center column
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier
            .fillMaxSize()
            .padding(24.dp),
        verticalArrangement = Arrangement.Center
    ) {
        // Photo (circle)
        Box(
            modifier = Modifier
                .size(200.dp)
                .clip(CircleShape)
                .border(4.dp, Color.White, CircleShape)
        ) {
            Image(
                painter = painterResource(Res.drawable.photo_5),
                contentDescription = "Mempelai",
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.Crop
            )
        }

        Spacer(modifier = Modifier.height(18.dp))

        // Nama mempelai (contoh: "A & B")
        Text(
            text = "Eva & Danu",
            fontSize = 32.sp,
            fontWeight = FontWeight.Bold,
            color = Color.White
        )

        Spacer(modifier = Modifier.height(12.dp))

        Text(
            text = "Dear",
            fontSize = 16.sp,
            color = Color(0xFFF0F0F0)
        )

        Spacer(modifier = Modifier.height(6.dp))

        // Nama tamu (dinamis)
        Text(
            text = guestName,
            fontSize = 20.sp,
            fontWeight = FontWeight.SemiBold,
            color = Color.White
        )

        Spacer(modifier = Modifier.height(20.dp))

        Button(
            onClick = {
                openHomeScreen(initialWonder) // sekarang hanya trigger animasi
            },
            colors = ButtonDefaults.buttonColors(containerColor = ColorScheme.primary),
            shape = RoundedCornerShape(12.dp),
            modifier = Modifier
                .width(200.dp)
                .height(48.dp)
        ) {
            Text(
                text = "Buka Undangan",
                color = Color.White,
                fontWeight = FontWeight.Bold
            )
        }
    }
}